var _defs, _circle, _circle2, _path, _circle3, _path2, _path3, _path4, _circle4, _circle5, _circle6, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_812",
    "data-name": "Group 812",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.301,
    height: 70.301,
    viewBox: "0 0 70.301 70.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 35.15,
    cy: 35.15,
    r: 35.15,
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 34.407,
    cy: 34.407,
    r: 34.407,
    transform: "translate(0.81 0.519)",
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M549.291,529.425a34.246,34.246,0,0,0,18.9-5.66c-1.268-6.928-6.093-7.325-6.093-7.325H535.505s-4.55.373-5.975,6.749A34.249,34.249,0,0,0,549.291,529.425Z",
    transform: "translate(-514.043 -459.955)",
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 16.609,
    cy: 16.609,
    r: 16.609,
    transform: "translate(18.274 17.592)",
    fill: "#f55f44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M366.53,416.8h10.643v8.514a5.32,5.32,0,0,1-5.32,5.32h0a5.32,5.32,0,0,1-5.32-5.32V416.8Z",
    transform: "translate(-337.006 -368.765)",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M367.553,415.5h8.611a1.016,1.016,0,0,1,1.016,1.016v7.5a5.32,5.32,0,0,1-5.32,5.32h0a5.32,5.32,0,0,1-5.32-5.32v-7.5a1.016,1.016,0,0,1,1.016-1.016Z",
    transform: "translate(-337.013 -367.859)",
    fill: "#fda57d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M575.88,498.9a15.317,15.317,0,0,0,10.643.03V497.62H575.88Z",
    transform: "translate(-546.335 -446.843)",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.63 22.26)",
    fill: "#fda57d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 6.139,
    cy: 6.139,
    r: 6.139,
    transform: "translate(28.723 11.168)",
    fill: "#f55f44"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 4.031,
    cy: 4.031,
    r: 4.031,
    transform: "translate(30.831 7.231)",
    fill: "#f55f44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M575.755,380.34a6.139,6.139,0,0,1-3.2-7.85c-.042.085-.085.173-.124.261a6.14,6.14,0,0,0,11.2,5.026c.039-.088.076-.176.112-.267A6.139,6.139,0,0,1,575.755,380.34Z",
    transform: "translate(-543.556 -359.666)",
    fill: "#f55f44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M557.67,399.309s6.427,13.042,24.568,5.46l-4.222-6.621-7.483-2.687Z",
    transform: "translate(-533.648 -375.669)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M557.67,398.669s6.427,13.042,24.568,5.46l-4.222-6.621-7.483-2.687Z",
    transform: "translate(-533.648 -375.223)",
    fill: "#f55f44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M574,391.314a75.781,75.781,0,0,1,11.884,0S577.106,392.13,574,391.314Z",
    transform: "translate(-545.025 -372.618)",
    fill: "#333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M594.36,353.234a4.039,4.039,0,0,0-.91.07h.234a4.028,4.028,0,0,1,.607,7.986,4.028,4.028,0,0,0,.073-8.056Z",
    transform: "translate(-558.575 -346.249)",
    fill: "#f55f44"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(18.208 34.838)",
    fill: "#fda57d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(48.718 34.838)",
    fill: "#fda57d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M345.22,333.475l2.975-1.535.67,2.46-1.823,1.241Z",
    transform: "translate(-322.159 -309.644)",
    fill: "#f55f44"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.fc3ea7e160e09ec5f735907486265a04.svg";
export { ForwardRef as ReactComponent };